/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 17:54 23.04.2023
 * @ Description: Page de trasition entre le niveaux 
 */


import "./index.css";
import React, {useEffect} from "react";
import GamePageManager from "../../utils/GamePageManager";
import GameAdmin from "../../GameClass/gameAdmin";
import api from "../../utils/api";

export default function GameLevelTransiton() {

    useEffect(()=>{
        api.getRandomSentence((data)=>{
            GameAdmin.instance.sentences.push(...data);
            /*
                rajoute un peux de temps pour permettre de voir 
                le loading, si non dans certain cas, il apparès 
                durant une frame et ça rent male (je trouve)
            */
            setTimeout(()=>GamePageManager.changePage("GameSentenceShower"),750);
        });
    },[]);

    return (
        <div className="GamePage GameLevelTrasition">
            <h1>Level {GameAdmin.instance.level+1}</h1>
        </div>
    );
}
